export const SpeakersLoadingState = () => {
  return <div className="min-h-[calc(100vh-64px)] bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
          <div className="space-y-6">
            {/* Header */}
            <div>
              <div className="h-8 w-48 bg-gray-200 rounded-lg mb-2" />
              <div className="h-5 w-72 bg-gray-200 rounded-lg" />
            </div>
            {/* Search Bar */}
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="relative flex-1">
                <div className="w-full h-10 bg-gray-200 rounded-lg" />
              </div>
            </div>
            {/* Topic filters */}
            <div className="space-y-2">
              <div className="h-5 w-16 bg-gray-200 rounded-lg" />
              <div className="flex flex-wrap gap-2">
                {[...Array(6)].map((_, i) => <div key={i} className="h-8 w-32 bg-gray-200 rounded-full animate-pulse" />)}
              </div>
            </div>
            {/* Speaker grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(6)].map((_, i) => <div key={i} className="p-4 border rounded-lg bg-white animate-pulse">
                  <div className="space-y-4">
                    <div className="aspect-square rounded-lg bg-gray-200" />
                    <div className="space-y-2">
                      <div className="h-6 bg-gray-200 rounded w-3/4" />
                      <div className="h-4 bg-gray-200 rounded w-1/2" />
                      <div className="h-4 bg-gray-200 rounded w-2/3" />
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {[...Array(3)].map((_, j) => <div key={j} className="h-6 w-20 bg-gray-200 rounded-full" />)}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
